import { BASE_URL } from '@/api'

const filters = {
  filterImg(value) {
    if (!value) return ''
    if (value.startsWith('http')) return value
    return BASE_URL + value
  },

  hiddenIdCard(str, startLen = 3, endLen = 4) {
    if (!str) return ''
    let len = str.length - startLen - endLen
    let stars = '*'.repeat(len)
    return str.substring(0, startLen) + stars + str.substring(str.length - endLen)
  }
}

export default filters
